import { useState } from "react";
import { Button, Input, Col, Row } from "reactstrap";
import { API_BASE_URL } from "../../constants/api.constants";
import axios from "../../services/api/api";
import FoundUserInfo from "../UserManagement/FoundUserInfo";
export default function FindUserInfo() {
  const [foundUser, setFoundUser] = useState({});

  const CheckUser = () => {
    if (foundUser.UserFound === false) {
      return <FoundUserInfo foundUser={foundUser} />;
    } else if (foundUser.UserFound === true) {
      return <FoundUserInfo foundUser={foundUser} />;
    } else {
      return null;
    }
  };

  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="col-3 mb-2">
          <h5 className="no-margin">Sök användare</h5>
        </Col>
      </Row>

      <Row className="search-row">
        <Col className="col-3">
          <Input id="user-search-email" placeholder="email" />
        </Col>
      </Row>
      <Row>
        <Col className="col-3 mt-2">
          <Button
            color="primary"
            outline
            onClick={() => {
              var userEmail = document
                .getElementById("user-search-email")
                .value.trim();

              axios
                .get(
                  `${API_BASE_URL}/User/ByEmail?email=${encodeURIComponent(
                    userEmail
                  )}`
                )
                .then((response) => {
                  var res = response?.data?.result;

                  if (res) {
                    setFoundUser({
                      UserFound: true,
                      Id: res.id,
                      IsDeleted: res.isDeleted,
                      Created: res.created,
                      Name: res.name,
                      Email: res.email,
                      Type: res.userType,
                      Activated: res.hasActivatedAccount,
                      HasFullTeacherAccess: res.hasFullTeacherAccess,
                      LicenceOnSchool: res.licenceOnSchool,
                      Schools: res.schools,
                      Classes: res.classes,
                      Licenses: res.coursesInLicense,
                      IsPurchaser: res.isPurchaser,
                      AplLicenseValidTo: res.aplLicenseValidTo,
                    });
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  setFoundUser({ UserFound: false, failMessage: failMessage });
                });
            }}
          >
            Sök
          </Button>
        </Col>
      </Row>
      {CheckUser()}
    </div>
  );
}
